module.exports = __webpack_public_path__ + "img/plane.f37fcf3b.svg";